var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYourMonitiringSystem = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "premiumIcon",
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M39.111 0H4.89A4.903 4.903 0 0 0 0 4.889V39.11C0 41.8 2.2 44 4.889 44H39.11C41.8 44 44 41.8 44 39.111V4.89C44 2.2 41.8 0 39.111 0zM14.667 34.222h-4.89v-17.11h4.89v17.11zm9.777 0h-4.888V9.778h4.888v24.444zm9.778 0h-4.889v-9.778h4.89v9.778z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYourMonitiringSystem);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/your-monitiring-system.16718154a24b1e94589cb021afed496f.svg";